<h2>Report for slider {{ slide.slide.title }}</h2>
<!--<hr class="mb-l">-->
<div class="row mb-xl">
  <div class="col-2">
    <div class="mb-l">
      <strong>Buchung</strong>
      <p>{{slide.slide.title}}</p>
    </div>
    <div class="mb-l">
      <strong>Werbeform</strong>
      <p>Slider</p>
    </div>
    <div class="mb-l">
      <strong>Zeitraum</strong>
      <p>{{getDate(slide.slide.start) | date: 'dd.MM.yyyy'}} - <br>{{getDate(slide.slide.end) | date: 'dd.MM.yyyy'}}</p>
    </div>
  </div>
  <div class="col-10"><div class="image-container"><img src="{{ CDN }}/marketing-management/{{slide.slide.image}}" alt="{{ slide.slide.title }}"/></div></div>

</div>
<div class="mb-l">
  <h3>Compared Slides:</h3>
  @for (compare of compares; track compare) {
    <p>{{compare.title}} {{compare.image}} {{getDate(compare.start) | date: 'dd.MM.yyyy'}} - {{getDate(compare.end) | date: 'dd.MM.yyyy'}}</p>
  }
</div>
<div class="performance-slide pt-xxl" id="{{getSlideId()}}" [attr.data-click]="click"  [attr.data-type]="'Slider'">
  <div class="row">
    <div class="col-2">
      Click-performance
    </div>
    <div class="col-10">
      <div class="click w-100 mb-l">
        <div class="d-flex">
          <div class="vis-1">
            @if (click <= 1) {
              <div class="marker" [style.left]="click * 100 + '%'">
                <div class="value d-flex flex-column text-center">
                  <small>{{ click }}</small>
                  <mat-icon>arrow_drop_down</mat-icon>
                </div>
              </div>
            }
          </div>
          <div class="vis-2">
            @if (click > 1) {
              <div class="marker" [style.left]="((click-1)/click) * 100 + '%'">
                <div class="value d-flex flex-column text-center">
                  <small>{{ click }}</small>
                  <mat-icon>arrow_drop_down</mat-icon>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="d-flex">
          <div class="red"></div>
          <div class="yellow"></div>
          <div class="green"></div>
        </div>
      </div>
    </div>
  </div>
</div>